export default __webpack_public_path__ + "languages/es.5fd5d4b2.pathmapping.json";